var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('button',{staticClass:"w-6 h-6",attrs:{"type":"button","aria-label":"Gebruik mijn locatie"},on:{"click":_vm.fillCity}},[_c('LocationService')],1):_c('div',{staticClass:"w-6 h-6 border-[3px] border-black/20 border-t-black/60 rounded-full animate-spin",attrs:{"aria-label":"Loading location"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }